import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import cn from 'classnames';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { TOOLTIP_HOVER_DELAY } from '../../../../constants';
import s from './EditorIconButton.scss';
const EditorIconButton = (_param)=>{
    var { isActive } = _param, props = _object_without_properties(_param, [
        "isActive"
    ]);
    return /*#__PURE__*/ React.createElement(IconButton, _object_spread({
        className: cn(s['root'], isActive && s['is-active']),
        size: "large",
        tooltipHoverDelay: TOOLTIP_HOVER_DELAY
    }, props));
};
EditorIconButton.displayName = 'EditorIconButton';
export default EditorIconButton;

//# sourceMappingURL=EditorIconButton.js.map